import {
    EndpointConfiguration as ForgeEndpointConfig,
    Stage as ForgeStage,
} from "@amzn/ads-forge-client";
import {
    EndpointConfiguration as AquilaEndpointConfig,
    Stage as AquilaStage,
} from "@amzn/aquila-service-type-script-client";

import { zustandStore } from "../store/zustand.helpers";

export interface AquilaConfigInfo {
    configId: string;
    awsAccountId: string;
}

export type AquilaConfig = {
    featureAccess: AquilaConfigInfo;
    homePageFeedbackForm: AquilaConfigInfo;
    insightDetailFeedbackForm: AquilaConfigInfo;
    yourInsightsTabReportIssueConfig: AquilaConfigInfo;
    allInsightsTabReportIssueConfig: AquilaConfigInfo;
    sidePanelReportIssueConfig: AquilaConfigInfo;
    createInsightDeckPageReportIssueConfig: AquilaConfigInfo;
    generalThumbsFeedbackConfig: AquilaConfigInfo;
    IHubFeatureRequestConfig: AquilaConfigInfo;
};

export interface AuthSettings {
    cognitoPoolId: string;
    apiEndpoint: string;
    region: string;
    stage: string;
    ppApiEndpoint: string;
    discoveryApiEndpoint: string;
    aquilaApiEndpoint: AquilaEndpointConfig;
    forgeApiEndpoint: ForgeEndpointConfig;
    aquilaConfig: AquilaConfig;
    g4sApiEndpoint: string;
    g4sApiInvocationRoleArn: string;
    adsApiEndpoint: string;
    plmApiEndpoint?: string;
    blinkAwsAccountId: string;
    blinkApiEndpoint: string;
    g4sServiceEndpoint: string;
    g4sServiceInvocationRoleArn: string;
    seleneApiEndpoint: string;
    magnetoApiEndpoint: string;
    magnetoPoolId: string;
    rumAppId: string;
    rumRegion: string;
    phoenixRumAppId: string;
    phoenixCognitoPoolId: string;
}

export interface AuthAccessRoles {
    plm: boolean;
}

export interface AuthState {
    username: string;
    settings: AuthSettings;
    accessRoles: AuthAccessRoles;
}

export interface AuthActions {
    setUsername: (username: string) => void;
    setSettings: (settings: AuthSettings) => void;
    setAccessRoles: (roles: AuthAccessRoles) => void;
    resetState: () => void;
}

export const initialState: AuthState = {
    settings: {
        cognitoPoolId: "",
        apiEndpoint: "",
        ppApiEndpoint: "",
        discoveryApiEndpoint: "",
        magnetoApiEndpoint: "",
        magnetoPoolId: "",
        adsApiEndpoint: "",
        g4sApiEndpoint: "",
        blinkApiEndpoint: "",
        blinkAwsAccountId: "",
        g4sServiceEndpoint: "",
        aquilaApiEndpoint: new AquilaEndpointConfig(AquilaStage.BETA),
        forgeApiEndpoint: new ForgeEndpointConfig(ForgeStage.BETA),
        aquilaConfig: {
            featureAccess: {
                configId: "",
                awsAccountId: "",
            },
            homePageFeedbackForm: {
                configId: "",
                awsAccountId: "",
            },
            insightDetailFeedbackForm: {
                configId: "",
                awsAccountId: "",
            },
            yourInsightsTabReportIssueConfig: {
                configId: "",
                awsAccountId: "",
            },
            allInsightsTabReportIssueConfig: {
                configId: "",
                awsAccountId: "",
            },
            sidePanelReportIssueConfig: {
                configId: "",
                awsAccountId: "",
            },
            createInsightDeckPageReportIssueConfig: {
                configId: "",
                awsAccountId: "",
            },
            generalThumbsFeedbackConfig: {
                configId: "",
                awsAccountId: "",
            },
            IHubFeatureRequestConfig: {
                configId: "",
                awsAccountId: "",
            },
        },
        g4sApiInvocationRoleArn: "",
        g4sServiceInvocationRoleArn: "",
        seleneApiEndpoint: "",
        region: "",
        stage: "",
        rumAppId: "",
        rumRegion: "",
        phoenixRumAppId: "",
        phoenixCognitoPoolId: "",
    },
    username: "",
    accessRoles: {
        plm: false,
    },
};

export const { store: authStore } = zustandStore<AuthState, AuthActions>(
    "Auth",
    initialState,
    (set: any) => ({
        setUsername: (username: string) =>
            set(() => ({
                username,
            })),
        setSettings: (settings: AuthSettings) =>
            set(() => ({
                settings: {
                    ...settings,
                },
            })),
        setAccessRoles: (accessRole: AuthAccessRoles) =>
            set(() => ({
                accessRoles: {
                    ...accessRole,
                },
            })),
        resetState: () => set(() => ({ ...initialState })),
    }),
);
